import { Component, Inject, OnInit, ElementRef,ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http'; // chỉ còn dùng cho API "Thêm vào danh sách"
import { map, startWith } from 'rxjs/operators';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { BehaviorSubject, Observable } from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service'

// Khớp đúng field response tài liệu: name, allName, serviceTypeName (không có id)
export interface ContractReviewItem {
    id: string;
    name: string;           // "Mã - Tên hợp đồng", BE đã format sẵn
    allName: string;        // Các bên ký kết, BE đã join sẵn
    serviceTypeName: string;
  }
  
  export interface ServiceTypeOption {
    id: string;
    name: string;
  }
  
  interface SearchContractParams {
    nameOrCode: string;
    serviceType: number | null;
    page: number;
    pageSize: number;
  }
  
  // Response trả về từ BE
  interface FilterReviewStandardizedContractResponse {
    currentPage: number;
    pageSize: number;
    totalRow: number;
    dataRow: ContractReviewItem[];
    isCompleted: boolean;
  }

@Component({
  selector: 'app-select-contract-review-dialog',
  templateUrl: './select-contract-review-dialog.component.html',
  styleUrls: ['./select-contract-review-dialog.component.scss'],
})
export class SelectContractReviewDialogComponent implements OnInit {
    readonly displayedColumns = ['select', 'stt', 'name', 'serviceType', 'allName'];

    @ViewChild('serviceTypeSearchInput', { static: false }) serviceTypeSearchInput: ElementRef<HTMLInputElement>;

    keywordControl = new FormControl('');
    serviceTypeControl = new FormControl(null); // lưu trực tiếp id, '' = "Tất cả"
  
    serviceTypeOptions: ServiceTypeOption[] = [];
    serviceTypeSearchText = '';
    private filteredContractTypeOptionsSubject = new BehaviorSubject<ServiceTypeOption[]>([]);
    filteredServiceTypeOptions: Observable<ServiceTypeOption[]> = this.filteredContractTypeOptionsSubject.asObservable();
  
    dataSource: ContractReviewItem[] = [];
  
    paginate: {
      currentPage: number;
      pageSize: number;
      totalRow: number;
      totalPage: number;
      totalPageArray: any[];
      no: any[];
    } = {
      currentPage: 0,    
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };

    isLoading = false;
    isSubmitting = false;
    errorMessage = '';

    private selectedMap = new Map<string, ContractReviewItem>();
  
    constructor(
      private dialogRef: MatDialogRef<SelectContractReviewDialogComponent>,
      private http: HttpClient,
      private documentService: DocumentService,
      private documentTypeService : DocumentTypeService,
      @Inject(MAT_DIALOG_DATA) public data: { selectedVersion: string },
    ) {}
  
    ngOnInit(): void {
      this.getServiceTypes();
      this.onSearch();
    }

    get selectedCount(): number {
      return this.selectedMap.size;
    }

    getServiceTypes() {
      this.documentTypeService
        .getServiceTypesMoha(localStorage.getItem('enterpriseId'))
        .subscribe(rs => {
          if (rs == null || rs.data == null) {
            return;
          }
          this.serviceTypeOptions = rs.data;
          this.filteredContractTypeOptionsSubject.next(rs.data);
        });
    }
  
    /** Gõ tìm trong danh sách loại hợp đồng khi dropdown đang mở */
    onServiceTypeSearchChange(): void {
      const kw = this.removeVietnameseTones(this.serviceTypeSearchText);
      const result = !kw
        ? this.serviceTypeOptions
        : this.serviceTypeOptions.filter((opt) =>
            this.removeVietnameseTones(opt.name).includes(kw));
      this.filteredContractTypeOptionsSubject.next(result);
    }

    private removeVietnameseTones(str: string): string {
      return (str || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase()
        .trim();
    }
  
    /** Reset ô search-box mỗi khi đóng/mở lại dropdown */
    onServiceTypeSelectOpenChange(opened: boolean): void {
      if (opened) {
        setTimeout(() => {
          if (this.serviceTypeSearchInput) {
            this.serviceTypeSearchInput.nativeElement.focus();
          } else {
            // dự phòng nếu ViewChild không bắt được (input nằm trong overlay)
            const input = document.querySelector('.select-search-input') as HTMLInputElement;
            if (input) {
              input.focus();
            }
          }
        });
      } else {
        this.serviceTypeSearchText = '';
        this.filteredContractTypeOptionsSubject.next(this.serviceTypeOptions);
      }
    }

    onSearchClick(): void {
      this.paginate.currentPage = 0;
      this.onSearch();
    }

    onChangePage(event: { page: number; pageSize: number }): void {
      this.paginate.currentPage = event.page;
      this.paginate.pageSize = event.pageSize;
      this.onSearch();
    }

    onContractTypeChange(): void {
      this.onSearch();
    }
  
    onSearch(): void {
      this.isLoading = true;
      this.errorMessage = '';
      this.dataSource = [];
    
      const serviceTypeId = this.serviceTypeControl.value;
      const params: SearchContractParams = {
        nameOrCode: (this.keywordControl.value || '').trim(),
        serviceType: serviceTypeId ? Number(serviceTypeId) : null,
        page: this.paginate.currentPage,       // 0-based, không trừ 1 nữa
        pageSize: this.paginate.pageSize,
      };
    
      this.documentService.getReviewStandardized(params).subscribe({
        next: (res) => {
          this.isLoading = false;
          const body = res.data;
          this.dataSource = body.dataRow || [];
    
          this.paginate.currentPage = body.currentPage;
          this.paginate.pageSize = body.pageSize;
          this.paginate.totalRow = body.totalRow;
          this.paginate.totalPage = Math.ceil(body.totalRow / body.pageSize);
          this.paginate.totalPageArray = Array.from({ length: this.paginate.totalPage }, (_, i) => i + 1);
        },
        error: () => {
          this.isLoading = false;
          this.errorMessage = 'search_form_standardize.dialog_select_contract_review.search_error';
        },
      });
    }

    isSelected(row: ContractReviewItem): boolean {
      return this.selectedMap.has(row.id);
    }          

    isAllSelected(): boolean {
      return this.dataSource.length > 0 && this.dataSource.every(r => this.selectedMap.has(r.id));
    }

    toggleAll(): void {
      if (this.isAllSelected()) {
        this.dataSource.forEach(r => this.selectedMap.delete(r.id));
      } else {
        this.dataSource.forEach(r => this.selectedMap.set(r.id, r));
      }
    }

    toggleRow(row: ContractReviewItem): void {
      this.selectedMap.has(row.id) ? this.selectedMap.delete(row.id) : this.selectedMap.set(row.id, row);
    }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAddToList(): void {
    if (!this.selectedMap.size) return;
  
    this.isSubmitting = true;
    this.errorMessage = '';
    const selectedItems = Array.from(this.selectedMap.values());
    const contractIds = selectedItems.map(i => i.id);
  
    this.documentService.addStandardizedContracts({ contractIds }).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.dialogRef.close(selectedItems);
      },
      error: () => {
        this.isSubmitting = false;
        this.errorMessage = 'search_form_standardize.dialog_select_contract_review.add_error';
      },
    });
  }
}